var React = require('react');
var createReactClass = require('create-react-class');
var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var PropTypes = require('prop-types');
var utils = require('../../../utils/utils');
var SurveyActions = require('../../../modules/survey/actions/surveys-initialize');
var latestScoreActions = require('../../../modules/latestScore/actions/latestScore');

var loadSurveys = function(Component) {
    var LoadComponent = createReactClass({
        getInitialState: function(){
            return {
                isUserPromisSurveyAlreadyTaked: false
            };
        },

      componentDidMount: function() {
          this.updateIsUserPromisSurveyAlreadyTakedState(this.props.latestScore.data);

          this.props.fetchLatestScore(this.props.auth.token);

          this.loadSurveys(this.props.params.surveyType);
      },

      componentWillReceiveProps: function(nextProps){
          if(nextProps.latestScore.data.submissionId && nextProps.latestScore.data.submissionId !== this.props.latestScore.data.submissionId){
              this.updateIsUserPromisSurveyAlreadyTakedState(nextProps.latestScore.data);
          }
          
          if(nextProps.params.surveyType !== this.props.params.surveyType){
              this.loadSurveys(nextProps.params.surveyType);
          }
      },

      updateIsUserPromisSurveyAlreadyTakedState: function(latestScore){
          this.setState({
              isUserPromisSurveyAlreadyTaked: utils.isSurveyCompleted(latestScore)
          });
      },

      loadSurveys: function(surveyType) {
        this.props.seedSurveysIfNeeded(surveyType, this.props.auth.user.sex);
      },

      render: function() {
         return this.props.surveys.index.length !== 0 && this.props.surveys.surveyType === this.props.params.surveyType.toLowerCase()
            && !this.props.latestScore.isFetching ?
            <Component isUserPromisSurveyAlreadyTaked={this.state.isUserPromisSurveyAlreadyTaked} {...this.props} /> : null;
      }
    });

    loadSurveys.propTypes = {
      seedSurveysIfNeeded: PropTypes.func.isRequired,
      surveys: PropTypes.object,
      auth: PropTypes.object
    };

  var mapStateToProps = function(state){
      return {
        surveys: state.surveys,
        auth: state.auth,
        latestScore: state.latestScore
      };
  }

  var mapDispatchToProps = function(dispatch) {
    return bindActionCreators(Object.assign({}, SurveyActions, latestScoreActions), dispatch);
  }

  return ReactRedux.connect(mapStateToProps, mapDispatchToProps)(LoadComponent);
};

module.exports = loadSurveys;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/loadSurveys.jsx